import { Component, OnInit, Input, Output, forwardRef, EventEmitter } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, NG_VALIDATORS, NG_VALUE_ACCESSOR, ControlValueAccessor, Validators, ReactiveFormsModule } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { AlertModal } from 'src/app/model/alert';
import { ModalComponent } from '../modal/modal.component';
import { ToolTipNotificationComponent } from '../../form-elements/tool-tip-notification/tool-tip-notification.component';
import { NgClass } from '@angular/common';



@Component({
    selector: 'app-address-lines',
  templateUrl: './address-lines.component.html',
  styleUrls: ['./address-lines.component.scss'],
    providers: [
        {
            provide: NG_VALIDATORS, useExisting: AddressLinesComponent, multi: true
        },
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => AddressLinesComponent),
            multi: true
        }
    ],
    imports: [ReactiveFormsModule, NgClass, ToolTipNotificationComponent, ModalComponent]
})
export class AddressLinesComponent implements OnInit {
  @Input() controllerData;
  @Input() parent: UntypedFormGroup;
  @Input() pageName: string;
  @Input() controlName: string;
  textValue: string;
  displayTooltipAlert = false;
  tooltipModal;
  public tooltipModalConfig: AlertModal;
  @Input() tooltipData: any;

  @Output() textChangeEventEmitter: EventEmitter<string> = new EventEmitter<string>();
  /**
   * This is a constructor
   */
  constructor(private fb: UntypedFormBuilder, private activatedRoute: ActivatedRoute,) {
    this.tooltipModal = this.activatedRoute.snapshot.data.contentData.tooltipModalConfig;

  }
  ngOnInit() {
    this.tooltipModalConfig = this.activatedRoute.snapshot.data.contentData.tooltipModalConfig;

    if (this.controllerData.validationRule) {
    }

    if (this.parent.get([this.controlName]) && this.pageName == 'beneficiaryDetails') {
      this.textValue = this.parent.get([this.controlName]).value;
    }
    else {
      this.textValue = this.controllerData.value;
    }

  }

  inputTextChangeHandler(val) {
    this.textChangeEventEmitter.emit(val);
  }

  validate() {
    // tslint:disable-next-line: max-line-length
    const nameReForpostCode: RegExp = /^[a-z][a-z\s]*$/;
    const forbidden = nameReForpostCode.test(this.parent.get(this.controlName).value);


    if (this.parent.get(this.controlName).value) {
      return forbidden ? null : { notValidname: true };
      // tslint:disable-next-line:align
    } return null;
  }

  displayTooltipMessage(el) {
    let config;

    config = this.tooltipData;
    this.tooltipModal.content = config.content;
    this.displayTooltipAlert = true;
  }

  closeTooltipModal() {
    this.displayTooltipAlert = false;
  }

  alertTooltipPrimaryBtnClick() {
    this.displayTooltipAlert = false;
  }
  alertSecondaryBtnClick() {
    this.closeTooltipModal();
  }
}
